module.exports = __webpack_public_path__ + "img/head_bg.c8645afd.png";